import { useState } from 'react';
import { CommonDropdown } from "../../common/CommonSelector";
import { useTheme } from 'styled-components';
import {Input,PrimaryButton} from 'cdk-radial'
import styled from 'styled-components';
import {IconDelete,IconButton} from 'cdk-radial'
import { useTranslation } from "react-i18next";

export const StyledFieldRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  @media (max-width: 1100px) {
    display: grid;
    max-width: 70%;
  }
`;

export default function ChartFieldSetting({
 widget,
 field,
 onChange
}: any) {

  const { showPercentage } = widget;
  const theme = useTheme();
  const {t} = useTranslation();

  const operators = [
    { value: 'gt', label: '> Greater than' },
    { value: 'gte', label: '>= Greater or equal' },
    { value: 'lt', label: '< Less than' },
    { value: 'lte', label: '<= Less or equal' },
    { value: 'eq', label: '= Equals' },
  ];

  const presetColors = [
    { color: '#98AE5B', bg: '#fee2e2', name: 'Green' },
    { color: '#D05858', bg: '#dcfce7', name: 'Red' },
    { color: '#E5B176', bg: '#fef9c3', name: 'Orange' },
    { color: '#F0D46F', bg: '#ffedd5', name: 'yellow' },
    { color: '#6196E5', bg: '#e0e7ff', name: 'Blue' },
    { color: '#808080', bg: '#ede9fe', name: 'Gray' },
  ];

  const defaultCondition = {
    operator: 'gt',
    value: '',
    color: '#98AE5B',
    backgroundColor: '#dcfce7',
    label: '',
  };
  const [newCondition, setNewCondition] = useState(defaultCondition);

  const currentThreshold = field.threshold || {
    type: 'absolute',
    conditions: [],
  };
  const currentConditions = currentThreshold.conditions || [];

  const thresholdOptions = [
  { value: 'absolute', label: 'Absolute Value' },
  ...(showPercentage ? [{ value: 'percentage', label: 'Percentage Change' }] : [])
 ];

  const selectedThresholdType =
    thresholdOptions.find((option: any) => option.value === currentThreshold.type) ||
    thresholdOptions[0];


  const handleThresholdSelection = (selectedOption: any) => {
      const newField = {
        threshold: {
          ...currentThreshold,
          type: selectedOption?.value || 'absolute',
        },
      };
      onChange(newField);
  }
  
  const handleOperatorSelection = (selectedOption: any) => {
    setNewCondition((prev) => ({
      ...prev,
      operator: selectedOption?.value,
    }))
  }

  const getOperatorLabel = (op: string) =>
    operators.find((o) => o.value === op)?.label || op;

  const addCondition = () => {
    const currentConditions = field.threshold?.conditions || [];
    const normalizedValue = String(newCondition.value ?? '').trim();
    const parsedValue = normalizedValue === '' ? 0 : parseFloat(normalizedValue);
    const conditionValue = Number.isNaN(parsedValue) ? 0 : parsedValue;
    const exists = currentConditions.some((cond: any) =>
      cond.operator === newCondition.operator &&
      cond.value === conditionValue 
    );
    if (!exists) {
      const newField = {
        threshold: {
          ...field.threshold,
          conditions: [...currentConditions, { ...newCondition, value: conditionValue }],
        },
      }
      onChange(newField);
    }
    setNewCondition({
      operator: 'gt',
      value: '',
      color: '#98AE5B',
      backgroundColor: '#dcfce7',
      label: '',
    });
  };

  const removeCondition = (index: number) => {
    const currentConditions = field.threshold?.conditions || [];
    const newField = {
      threshold: {
        ...field.threshold,
        conditions: currentConditions.filter(
          (_: any, i: number) => i !== index
        ),
      },
    }
    onChange(newField);
  };


  return (
      <div>
        <div style={{marginBottom: '10px'}}>
        <CommonDropdown
                options={thresholdOptions as any}
                name="threshold"
                label={t('dashboard.settings.thresholdType') as any}
                placeholder=""
          selectedOption={selectedThresholdType}
                onSelect={handleThresholdSelection} />
        </div>
        <div style={{marginBottom: '10px'}}>
          <div style={{padding: '8px',
                      backgroundColor: theme.darkMode ? 'rgb(26, 26, 26)' : '#f8fafc',
                      borderRadius: '8px',}}> 
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        marginBottom: '12px',
                      }}
                    >
                      {t('dashboard.settings.addNewCond')}
                    </div>
                      <StyledFieldRow>
                      <div style={{ flex: 1 }}>
                          <CommonDropdown
                            options={operators as any}
                            name="threshold"
                            label={t('dashboard.settings.operator') as any}
                            placeholder=""
                            selectedOption={operators.find(opt => opt.value === newCondition.operator)as any}
                            onSelect={handleOperatorSelection} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Input
                                dataTestId={`condition-value`}
                                errorMessage={""}
                                id={`condition-value`}
                                inputDivider="left"
                                label={t('dashboard.settings.value') as any}
                                name={'value'}
                                onChange={(e: any) => {
                                  const inputValue = e.target.value;
                                  if (/^-?\d*\.?\d*$/.test(inputValue)) {
                                    setNewCondition((prev) => ({
                                      ...prev,
                                      value: inputValue,
                                    }))
                                  }
                                }}
                                placeholder={'Enter value'}
                                value={newCondition.value}
                                maxLength={10}
                                autocomplete={"off"}
                              />
                      </div>
                    </StyledFieldRow>
                    <StyledFieldRow>
                      <div style={{ flex: '1'  }}>
                        <Input
                                dataTestId={`label`}
                                errorMessage="Please enter a valid label"
                                id={`label`}
                                inputDivider="left"
                                label={t('dashboard.settings.label') as any}
                                name={'label'}
                                onChange={(e: any) => setNewCondition((prev) => ({
                                  ...prev,
                                  label: e.target.value,
                                }))}
                                placeholder={'e.g., Critical, Warning, Good'}
                                value={newCondition.label ||''}
                                maxLength={10}
                              />
                      </div>

                      <div style={{ flex: '1' ,marginTop:'0px'}}>
                        <div >
                          <span style={{fontSize:'0.75rem', 
                            marginLeft:'3px',
                            color: theme.darkMode ? 'rgba(255, 255, 255, 0.7)': 'rgba(0, 0, 0, 0.7)'
                            }}>{t('dashboard.settings.color')}</span>
                        </div>
                        <div style={{
                                display: 'flex',
                                gap: '8px',
                                flexWrap: 'wrap',
                              }}>
                            {presetColors.map((preset) => (
                              <div
                                key={preset.color}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  border: '2px solid transparent',
                                  backgroundColor: preset.color,
                                  ...(newCondition.color === preset.color
                                    ? {border: '2px solid #1e293b'}
                                    : {}),
                                }}
                                onClick={() =>
                                  setNewCondition((prev) => ({
                                    ...prev,
                                    color: preset.color,
                                    backgroundColor: preset.bg,
                                  }))
                                }
                                title={preset.name}
                              />
                            ))}
                          </div>
                      </div>
                      </StyledFieldRow>     

                    <StyledFieldRow>
                      <PrimaryButton
                        style={{ marginTop: '20px' }}
                        dataTestId="ip-template-button"
                        iconColor="primary"
                        onClick={addCondition}
                        text={t('dashboard.settings.addCondition') as any}
                      />
                    </StyledFieldRow>
                </div>
                  <div style={{ marginTop: '10px' }}>
                    <label >{t('dashboard.settings.condFor')} "{field.name}"</label>
                    {currentConditions.length === 0 ? (
                      <div style={{padding: '24px',
                                  textAlign: 'center',
                                  color: '#94a3b8',
                                  fontSize: '14px',}}>
                        {t('dashboard.settings.noCond')}
                      </div>
                    ) : (
                      currentConditions.map((condition: any, index: number) => (
                        <div key={index} style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '12px',
                                  padding: '6px',
                                  backgroundColor: theme.darkMode ? 'rgb(26, 26, 26)' : '#f8fafc',
                                  borderRadius: '8px',
                                  marginBottom: '8px',
                                }}>
                          <div
                            style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              flexShrink: 0,
                              backgroundColor: condition.color,
                            }}
                          />
                          <div style={{
                                flex: 1,
                                fontSize: '14px',
                              }}>
                            {condition.label && <strong>{condition.label}: </strong>}
                            {getOperatorLabel(condition.operator)}{' '}
                            {condition.operator === 'between'
                              ? `${condition.min?.toLocaleString()} - ${condition.max?.toLocaleString()}`
                              : condition.value?.toLocaleString()}
                            {currentThreshold.type === 'percentage' && '%'}
                          </div>

                          <IconButton
                          icon={<IconDelete />}
                          onClick={()=>removeCondition(index)}
                          onKeyDown={function Ove(){}}
                          text="Primary Button"
                        />
                        </div>
                      ))
                    )}
                  </div>
          </div>
      </div>
  );
}
